import isUrl from 'is-url'
import imageExtensions from 'image-extensions'
import {
  Transforms
} from 'slate'
import { useSelected, useFocused, useSlateStatic } from 'slate-react'
import { EditorButton } from './index'
import { css } from '@emotion/css'
import { resizeBase64Image } from '@/services/media/EmbeddedHandler'
import draftService from '@/app-domains/messages/draft/writing.service'
import ToastService from '@/components/Toast/Toast.service'

export const withImages = editor => {
  const { insertData, isVoid } = editor

  editor.isVoid = element => {
    return element.type === 'image' ? true : isVoid(element)
  }

  editor.insertData = async data => {
    const text = data.getData('text/plain')
    const { files } = data

    if (files && files.length > 0) {
      for (const file of files) {
        // eslint-disable-next-line no-undef
        const reader = new FileReader()
        const [mime] = file.type.split('/')

        if (mime === 'image') {
          reader.addEventListener('load', async () => {
            const url = reader.result
            const base64ResizedImage = await resizeBase64Image(url)
            ToastService.show({
              type: 'info',
              title: 'Uploading',
              message: 'Uploading embedded image ... ',
            })
            const embeddedUrlData = await draftService.uploadEmbeddedImage(base64ResizedImage)
            insertImage(editor, embeddedUrlData.url)
            ToastService.show({
              type: 'success',
              title: 'Succcess!',
              message: 'Image uploaded successfully',
            })
          })

          reader.readAsDataURL(file)
        }
      }
    } else if (isImageUrl(text)) {
      insertImage(editor, text)
    } else {
      insertData(data)
    }
  }

  return editor
}

const insertImage = (editor, url) => {
  const text = { text: '' }
  const image = { type: 'image', url, children: [text] }
  Transforms.insertNodes(editor, image)
}

export const Image = ({ attributes, children, element }) => {
  // const editor = useSlateStatic()
  // const path = ReactEditor.findPath(editor, element)

  const selected = useSelected()
  const focused = useFocused()
  return (
    <div {...attributes}>
      {children}
      <div
        contentEditable={false}
        className={css`
          position: relative;
        `}
      >
        <img
          src={element.url}
          className={css`
            display: block;
            max-width: 100%;
            box-shadow: ${selected && focused ? '0 0 0 3px #B4D5FF' : 'none'};
          `}
        />
      </div>
    </div>
  )
}

const isImageUrl = url => {
  if (!url) return false
  if (!isUrl(url)) return false
  const ext = new URL(url).pathname.split('.').pop()
  return imageExtensions.includes(ext)
}

export const InsertImageButton = ({ children, format, isBlockActive }) => {
  const editor = useSlateStatic()
  return (
    <EditorButton
      active={isBlockActive(editor, format)}
      onMouseDown={event => {
        event.preventDefault()
        const inputEl = document.createElement('input')
        inputEl.setAttribute('type', 'file')
        inputEl.addEventListener('change', function () {
          const files = inputEl.files
          if (files.length) {
            // eslint-disable-next-line no-undef
            const reader = new FileReader()
            reader.addEventListener('load', () => {
              const url = reader.result
              insertImage(editor, url)
            })
            reader.readAsDataURL(files[0])
          }
        }, false)
        inputEl.click()
      }}
    >
      {children}
    </EditorButton>
  )
}
